__turbopack_context__.v({
  "bulletList": "staticTemplate-module-scss-module__ZXTNxa__bulletList",
  "container": "staticTemplate-module-scss-module__ZXTNxa__container",
  "containerSticky": "staticTemplate-module-scss-module__ZXTNxa__containerSticky",
  "content": "staticTemplate-module-scss-module__ZXTNxa__content",
});
